module.exports = __webpack_public_path__ + "img/danger-yellow.67993db5.svg";